import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=361170f6&"
import script from "./Documentation.js?vue&type=script&lang=js&"
export * from "./Documentation.js?vue&type=script&lang=js&"
import style0 from "./Documentation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports